import { simpleFetch } from './customFetch';

export const getInviteContext = () => simpleFetch(
  '/1/teams/invited-by/invite-code', {}, process.env.REACT_APP_ACE_API,
);
